import 'katex/dist/katex.min.css';
import { useEffect, useState } from 'react';
// import { InlineMath, BlockMath } from 'react-katex';
import "./Description.css"
import problems_json from '../../../Data/Problems.json'
import Attempts from './PreviousAttempts/Attempts';
import Video from './Video/Video';
import SolutionCode from './SolutionCode/SolutionCode';


export default function Description({problemID}){
    
    const [option_selected, set_option_selected] = useState("Description");
    const [previous_attempts, set_previous_attempts] = useState([]); // Lifted one level so to effectivley cache the db query


    let selected_problem = problems_json.find(prob => {
        return prob.problem_id == problemID
    });
    const [problem_name, set_problem_name] = useState(selected_problem.problem_name)


    useEffect(() =>{
        selected_problem = problems_json.find(prob => {
            return prob.problem_id == problemID
        });
        set_problem_name(selected_problem.problem_name)
    }, [problemID])

    return(
        <div className='description-container-subpage'>
            
            <div className='top-bar-options-container'>

                <button className='problem option' onClick={() => set_option_selected("Description")}>
                        <svg
                            className='problem-svg'
                            xmlns="http://www.w3.org/2000/svg"
                            width="18" height="18"
                            viewBox="0 0 512 560"
                            role="img"
                            aria-labelledby="problemIconTitle"
                        >
                            <title id="problemIconTitle">Problem Icon</title>
                            {/* <!-- border --> */}
                            <rect x="16" y="16" width="480" height="525" rx="64" fill="none"
                                    stroke="#616161" stroke-width="32"/>
                            {/* <!-- all interior strokes --> */}
                            <g stroke="#b3b1b1" stroke-width="30" stroke-linecap="round">
                                {/* <!-- T (no base) --> */}
                                <line x1="144" y1="120" x2="304" y2="120"/>
                                <line x1="224" y1="136" x2="224" y2="296"/>
                                {/* <!-- 3 little text‐lines --> */}
                                <line x1="336" y1="160" x2="448" y2="160"/>
                                <line x1="336" y1="224" x2="448" y2="224"/>
                                <line x1="336" y1="288" x2="448" y2="288"/>
                                {/* <!-- 3 wide bars at bottom --> */}
                                <line x1="128" y1="352" x2="384" y2="352"/>
                                <line x1="128" y1="416" x2="384" y2="416"/>
                                <line x1="128" y1="480" x2="384" y2="480"/>
                            </g>
                        </svg>
                    <div className='text-wrapper'>Problem</div>  
                </button>

                <button className='option video' onClick={() => set_option_selected("Video")}>
                        <svg 
                            className='camera-svg'
                            xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ff3030bf"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round">
                        {/* <!-- camera body --> */}
                        <rect x="2" y="6" width="14" height="12" rx="2" ry="2"/>
                        {/* <!-- trapezoidal “lens” head --> */}
                        <path d="M16 8 L22 6 L22 18 L16 16"/>
                        </svg>

                        <div className='text-wrapper'>Video</div>
                </button >

                <button className='option code' onClick={() => set_option_selected("Code")}>
                    <svg
                            className='code-svg'
                            xmlns="http://www.w3.org/2000/svg"
                            width="30px"
                            height="20px"
                            viewBox="0 0 30 24"
                            fill="none"
                        >
                        <text
                            x="50%"
                            y="50%"
                            text-anchor="middle"
                            dominant-baseline="central"
                            font-family="monospace"
                            font-size="14"
                            fill="#61dafb"
                        >
                            &lt;/&gt;
                        </text>
                    </svg>
                    <div className='text-wrapper'>Code</div> 
                </button>

                <button className='option submissions' onClick={() => set_option_selected("Attempts")}>
                    <svg className="submissions-svg" width="17" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="title">
                        <defs>
                        <linearGradient id="yo" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stop-color="#FFD54F"/>
                        <stop offset="100%" stop-color="#FB8C00"/>
                        </linearGradient>
                        <marker id="arrowhead" markerWidth="6" markerHeight="6"
                                refX="1.5" refY="2.5" orient="auto"> 
                        <path d="M0.5,0.5 L4.5,2.5 L0.5,4.5 Z"
                                fill="#FB8C00"
                                stroke="#FB8C00"
                                stroke-width="0.7"
                                stroke-linejoin="round"
                                stroke-linecap="round"/>
                        </marker>
                    </defs>

                    <path d="M12 4
                            A8 8 0 1 0 20 12"
                            stroke="url(#yo)"
                            stroke-width="2"
                            stroke-linecap="round"
                            fill="none"
                            marker-end="url(#arrowhead)"/>
                    </svg>
                    <div className='text-wrapper'>Attempts</div>
                </button>
            
            </div>

            <div className='bottom-line'/>

            { // Description
                option_selected === "Description" && 
                <>
                    <div className='problem-title'>
                        {selected_problem.problem_name} 
                    </div>
                    <div className='problem-description'>
                    {selected_problem.problem_description}
                    </div>
                </>
                    
            }
            { // Video
                option_selected === "Video" && 
                    <Video/>
            }
            { // Code
                option_selected === "Code" && 
                
                    <div>
                        <SolutionCode problemID={problemID}/>
                    </div>
            }
            { // Attempts
                 option_selected === "Attempts" && 
                 <Attempts problemID={problemID} previous_attempts={previous_attempts} set_previous_attempts={set_previous_attempts} />
            }
        </div>
    );
}